var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: { d: "M4.73594 1.6H17.5359V16H19.1359V0H4.73594V1.6Z" }
      }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M4.73594 15.2H10.3359V13.6H4.73594V15.2Z" } }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M4.73594 6.39999H12.7359V11.2H4.73594V6.39999Z" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M1.53613 20V3.2H15.9361V20H1.53613ZM3.13613 4.8H14.3361V18.4H3.13613V4.8Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }